/*
  RevoRope — vídeo de fondo perezoso (no descargar hasta que se acerque al viewport).

  Motivo: el vídeo de "Cómo funciona" llegó a pesar el 46% de la Home y se
  descargaba igual estuviera visible o no (hallazgo del audit de rendimiento del
  30/07/2026). Los <video> afectados salen con `preload="none"` y sin `autoplay`
  desde Liquid (sections/como-funciona.liquid); este script es quien decide cuándo
  arrancan de verdad.

  Independiente de rr-reveal.js (eso sólo anima opacidad/transform, nunca toca
  cuándo se descarga un recurso). Selector deliberadamente scopeado a
  video[preload="none"] dentro de .rr-como__media: si algún día otra sección
  quiere vídeo SIEMPRE eager (p. ej. el hero, que va sobre el pliegue), le basta con
  no ponerle preload="none" y este script lo ignora.
*/
(function () {
  'use strict';

  /* Ojo con el `:not(...)`: desde el 22/08/2026 "Cómo funciona" puede ser una
     CINTA de hasta 5 vídeos, y ahí el criterio de este observador deja de valer.
     Todas las diapositivas están a la misma altura, así que entran en el
     viewport a la vez y este script las arrancaría TODAS de golpe, que es
     exactamente el problema de peso que vino a resolver. En cuanto hay cinta
     manda assets/rr-cinta.js, que reproduce sólo la diapositiva activa.
     Con un único vídeo no hay `[data-rr-cinta]` y esto sigue funcionando igual
     que siempre. */
  var SEL = '.rr-como__media video[preload="none"]';
  var FUERA = '[data-rr-cinta]';

  function arranca(video) {
    if (video.dataset.rrLazyStarted) return;
    video.dataset.rrLazyStarted = '1';
    video.preload = 'auto';
    video.play().catch(function () {
      // Autoplay bloqueado (política del navegador): el poster se queda quieto,
      // no es un error que haya que resolver aquí.
    });
  }

  var videos = Array.prototype.slice.call(document.querySelectorAll(SEL))
    .filter(function (v) { return !v.closest(FUERA); });
  if (!videos.length) return;

  if (!('IntersectionObserver' in window)) {
    videos.forEach(arranca);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        arranca(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '600px 0px', threshold: 0 });

  videos.forEach(function (video) { io.observe(video); });
})();
